<template>
  <el-row :gutter="0">
    <el-card class="commission-card">
        <div slot="header">
          <span>佣金概况</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="withdrawClick">提现</el-button>
        </div>
        <el-col  :span="18">
            <div :ref="className" :style="{height:height,width:width}" />
        </el-col>
        <el-col  :span="6">
          <el-row>
            <el-col :span="24">
              <div>
                <el-statistic group-separator="," :precision="2" :value="countWithdrawalCommissionData.totalUseMoney" :title="title" :value-style="{'color':'#5470C6'}">
                  <template slot="title">
                    <el-tooltip content="截止当日未提现佣金总额" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                    当前佣金
                  </template>
                </el-statistic>
              </div>
            </el-col>
            <el-col :span="24">
              <div>
                <el-statistic group-separator="," :precision="2" :value="countWithdrawalCommissionData.waitSettleMoney" title="待结算" :value-style="{'color':'#91CC75'}"></el-statistic>
              </div>
            </el-col>
            <el-col :span="24">
              <div>
                <el-statistic group-separator="," :precision="2" :value="countWithdrawalCommissionData.canWithdrawalMoney" title="可提现" :value-style="{'color':'#FAC858'}">
                  <template slot="title">
                    <el-tooltip content="截止上月底可提现佣金总额（当月15日之后可提上月及之前所有佣金）" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                    可提现
                  </template>
                </el-statistic>
              </div>
            </el-col>
            <el-col :span="24">
              <div>
                <el-statistic group-separator="," :precision="2" :value="countWithdrawalCommissionData.drawingMoney" title="提现中" :value-style="{'color':'#EE6666'}"></el-statistic>
              </div>
            </el-col>
          </el-row>
        </el-col>
    </el-card>
  </el-row>
</template>
<script>
import * as echarts from "echarts";
import {countWithdrawalCommission} from "@/api/api.js";
export default {
  name: 'commissionAccount',
  data() {
    return {
      chart:null,
      title:"当前佣金",
      countWithdrawalCommissionData:{
        drawingMoney:0,
        canWithdrawalMoney:0,
        waitSettleMoney:0,
        totalUseMoney:0
      },
      countWithdrawalChart:[
        { value: 0, name: '当前佣金' },
        { value: 0, name: '待结算' },
        { value: 0, name: '可提现' },
        { value: 0, name: '提现中' }
      ]
    }
  },
  props: {
    className: {
      type: String,
      default: 'myChart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '230px'
    }
  },
  methods: {
    withdrawClick(){
      this.$router.push('/scale/withdraw')
    },
    initChart() {
      this.chart = echarts.init(this.$refs.myChart);
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: this.countWithdrawalChart,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    countWithdrawalCommissionMethod(){
        countWithdrawalCommission().then(res=>{
            this.countWithdrawalCommissionData = res.data.data;
            let data = [];
            let totalUseMoney = {value:this.countWithdrawalCommissionData.totalUseMoney,name:"当前佣金"};
            data.push(totalUseMoney);
            let waitSettleMoney = {value:this.countWithdrawalCommissionData.waitSettleMoney,name:"待结算"};
            data.push(waitSettleMoney);
            let canWithdrawalMoney = {value:this.countWithdrawalCommissionData.canWithdrawalMoney,name:"可提现"};
            data.push(canWithdrawalMoney);
            let drawingMoney = {value:this.countWithdrawalCommissionData.drawingMoney,name:"提现中"}
            data.push(drawingMoney);
            this.countWithdrawalChart = data;
            this.initChart()
        })
    }  
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  created(){
    this.countWithdrawalCommissionMethod();
  }
}
</script>
<style lang="scss" scoped>
  .commission-card{
    height: 320px;
  }
  .el-col {
    margin-bottom: 6px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>


